<template>
  <formatted-text-input
    v-bind="{ label, required, requiredClass, requiredText, id, name, placeholder, readonly, error, disabled }"
    :options="options"
    :classes="[isValid ? inputValidClass : false, classes]"
    :right-icon="isValid ? iconValid : ''"
    :icon-class="isValid ? iconsValidClass : false"
    @input="emit">
    <slot />
  </formatted-text-input>
</template>

<script>
import * as props from '../mixins/props'
import cardValidator from 'card-validator'

export default {

  mixins: [
    props.classes,
    props.disabled,
    props.error,
    props.id,
    props.label,
    props.name,
    props.placeholder,
    props.readonly,
    props.required,
  ],

  props: {
    length: {
      type: Number,
      required: true,
    },
    iconValid: {
      type: String,
      default: 'check',
    },
    iconsValidClass: {
      type: String,
      default: 'has-text-success',
    },
    inputValidClass: {
      type: String,
      default: 'is-success',
    },
  },

  data: () => ({
    isValid: false,
  }),

  computed: {
    options() {
      return {
        numeral: true,
        numeralThousandsGroupStyle: 'none',
        numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        numeralIntegerScale: this.length,
        stripLeadingZeroes: false
      }
    }
  },

  methods: {
    emit(value) {
      let validation = cardValidator.cvv(value, this.length)
      this.isValid = validation.isValid
      this.$emit('input', value)
      this.$emit('valid', this.isValid)
    },
  },
}
</script>
